import Furnished from '@/images/icons/scheduleCard/furnished.svg';
import KeyDisabled from '@/images/icons/scheduleCard/key-disabled.svg';
import Key from '@/images/icons/scheduleCard/key.svg';
import LightningDisabled from '@/images/icons/scheduleCard/lightning-disabled.svg';
import Lightning from '@/images/icons/scheduleCard/lightning.svg';
import Locked from '@/images/icons/scheduleCard/locked.svg';
import PeopleDisabled from '@/images/icons/scheduleCard/people-disabled.svg';
import People from '@/images/icons/scheduleCard/people.svg';
import SemiFurnished from '@/images/icons/scheduleCard/semi-furnished.svg';
import StarDisabled from '@/images/icons/scheduleCard/star-disabled.svg';
import Star from '@/images/icons/scheduleCard/star.svg';
import Unfurnished from '@/images/icons/scheduleCard/unfurnished.svg';
import Unlocked from '@/images/icons/scheduleCard/unlocked.svg';
import Warningdisabled from '@/images/icons/scheduleCard/warning-disabled.svg';
import Warning from '@/images/icons/scheduleCard/warning.svg';

const iconByName = {
  unlocked: Unlocked,
  locked: Locked,
  unfurnished: Unfurnished,
  furnished: Furnished,
  'semi-furnished': SemiFurnished,
  people: People,
  'people-disabled': PeopleDisabled,
  'key-disabled': KeyDisabled,
  key: Key,
  'lightning-disabled': LightningDisabled,
  lightning: Lightning,
  'star-disabled': StarDisabled,
  star: Star,
  'warning-disabled': Warningdisabled,
  warning: Warning,
};

function orderCardIcon(iconName) {
  return iconByName[iconName] || '';
}

export default orderCardIcon;
